import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";
import { pickLegalText, useLegalTextCurrent } from "@/lib/data";

// =============================================================================
// Mention courte IA (A3) : affichée sous chaque écran IA (analyse Noa côté
// salarié et Aon, assistant). Texte administrable via legal_texts(kind =
// 'ia_mention'), avec repli sur la traduction par défaut.
// =============================================================================

export function IaMention({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const { data } = useLegalTextCurrent("ia_mention");
  const text = pickLegalText(data, i18n.language) || t("legal.ia.mention_default");
  return (
    <p className={className ?? "flex items-start gap-1.5 text-xs text-ink-subtle"}>
      <Sparkles className="mt-0.5 size-3.5 shrink-0" aria-hidden />
      <span>
        {text}{" "}
        <a
          href="/confidentialite#ia"
          target="_blank"
          rel="noreferrer"
          className="font-medium text-brand hover:underline"
        >
          {t("legal.ia.learn_more")}
        </a>
      </span>
    </p>
  );
}
